import { createAction } from 'redux-actions';

export const clearReservationUpcoming = createAction(
  'CLEAR_RESERVATION_UPCOMING'
);

export const reservationUpcomingOnChangePage = createAction(
  'RESERVATION_UPCOMING_ON_CHANGE_PAGE'
);

export const reservationUpcomingOnChangeOrder = createAction(
  'RESERVATION_UPCOMING_ON_CHANGE_ORDER'
);
